import { render } from "./08-01-24-PanelItem.vue?vue&type=template&id=eece5ed8"
import script from "./08-01-24-PanelItem.vue?vue&type=script&lang=js"
export * from "./08-01-24-PanelItem.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"08-01-24-PanelItem.vue"]])

export default __exports__